import React, { Component } from 'react';
import { firebaseAuth,ref } from '../config/constants'
import moment from 'moment'


import Sidebar from './inc/Sidebar';
import Header from './inc/Header';
import Title from './inc/Title';
import Footer from './inc/Footer';
import DisplayDelivery from './DisplayDelivery'
import DrPrint from './DrPrint'

class DeliveryReciept extends Component {

    constructor(){
        super();
        this.handleChange =this.handleChange.bind(this)
        this.handleSave =this.handleSave.bind(this)
        this.state={
            quotation :{},
            info : {},
            products : {},
            temp :{},
            quoteNumber : ""
        }
    }

    componentWillMount() {

        this.listener = firebaseAuth().onAuthStateChanged(user=>{
            if (user){
                var db = ref.child("users").child(user.uid);
                    db.on("value",function(data){
                      
                        this.setState({
                            userId:data.key,
                            user:data.val()
                        });

                    }.bind(this));
            }else{
                this.props.history.push("/login");
            }

        });
        
        let quotation = ref.child("Quotation").orderByChild("status").equalTo("Deal");
            quotation.on("value", function(snap){
                this.setState({
                    quotation : snap.val()
                })
            }.bind(this))
            
    } 
    

    handleChange(e){
        Object.keys(this.state.quotation).map(function (key){
                let list = this.state.quotation[key]
                if(list.quoteNumber === e.target.value){
                    this.setState({
                        info : list.customer,
                        products : list.products,
                        quoteNumber : e.target.value

                    })
                }
        }.bind(this))
    }

    handleSave(){
       
       let refer = this.refs
        Object.keys(refer).map((key)=>{
            let temp = this.state.temp
                temp[key] = {
                    qty : refer[key].refs.productNumber.value,
                    unit : refer[key].refs.productUnit.value,
                    name : refer[key].refs.productName.value,
                }
                this.setState({temp})
        })
        let customer={
            name : this.customerName.value,
            location : this.address.value
        }
        let save={
            quoteNumber : this.quotationNumber.value,
            customer : customer,
            products : this.state.temp,
            date : moment().format("MM DD YYYY")

        }
        let statusUpdate={
            deliveryStatus : "Delivered"
        }
        //console.log(this.state.temp)
        ref.child("Quotation").child(this.quotationNumber.value).update(statusUpdate)
        ref.child("Delivery").push(save).then(alert("New Delivery Reciept has been added"))
        this.setState({
            products : {},
            info : {}
        })

    }
    render() {
            
            
        return (                        
            <div id="page-wrapper">
                <div id="moveDr">
                    <div id="page-container" className="sidebar-partial sidebar-visible-lg sidebar-no-animations">
                        <Sidebar  />
                        <div id="main-container">
                            <Header />
                            <div id="page-content">
                                <Title title="Delivery Reciept" />
                                <div className="block">
                                    <div className="block full" id="react-no-print">
                                        <div className="block-title">
                                          <h2><strong>Create</strong> Delivery Reciept</h2>
                                        </div>
                                    
                                        <div className="row form-group">
                                            <label className="col-lg-2 col-md-3 text-right">Quotation Number</label>
                                            <div className="col-lg-2 col-md-3">
                                                <select className="form-control"  name="quotationNumber" ref={input=>this.quotationNumber=input} onChange={this.handleChange}>
                                                    <option></option>                                            
                                                    { 
                                                        this.state.quotation &&
                                                        Object.keys(this.state.quotation).map(function (key){
                                                            let list = this.state.quotation[key]
                                                            if(list.deliveryStatus!=="Delivered"){
                                                                return <option value={list.quoteNumber} key={key}> {list.quoteNumber} </option>
                                                            }
                                                       }.bind(this))
                                                    }
                                                </select>
                                            </div>
                                        </div>                                    

                                        <div className="row">
                                            <div className="form-group col-md-6">
                                                <label className="col-md-4 text-right">To</label>
                                                <div className="col-md-8">
                                                    <input className="form-control"  ref={input=>this.customerName=input} type="text" value={this.state.info && this.state.info.name}required/>
                                                </div>
                                            </div>
                                            <div className="form-group col-md-6">
                                                <label className="col-md-4 text-right">Address</label>
                                                <div className="col-md-8">
                                                    <input className="form-control"  ref={input=>this.address=input} type="text"  value={this.state.info && this.state.info.location} required/>
                                                </div>
                                            </div>
                                        </div>

                                        <table id="ecom-products" className="table table-bordered table-striped table-vcenter">
                                            <thead>
                                                <tr>               
                                                    <th className="text-center">QTY</th>
                                                    <th className="text-center">Unit</th>
                                                    <th className="text-center">Articles</th>
                                                    
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.products &&
                                                        Object.keys(this.state.products).map(function (key){
                                                            let list = this.state.products[key]
                                                            return <DisplayDelivery ref={key} key={key} product = {list} />
                                                       }.bind(this))
                                                }
                                            </tbody>
                                        </table>
                                        <div className="submitContract text-center">
                                            <button type="button" className="btn btn-primary" onClick={this.handleSave}><i className="fa fa-floppy-o"></i> Save</button>
                                            <button type="button" className="btn btn-primary pull-right" onClick={()=>window.print()}><i className="fa fa-print"></i> Print</button>
                                        </div> 
                                    </div>
                                    <div>
                                        <DrPrint quoteNumber={this.state.quoteNumber} products={this.state.products} name={this.state.info.name} address={this.state.info.location}/>
                                    </div>    
                                </div>
                            </div>
                            <Footer />
                        </div>
                    </div>
                </div>
            </div>
      
        );
    }
}

export default DeliveryReciept;



// WEBPACK FOOTER //
// ./src/components/DeliveryReciept.js